import { useQuery } from 'react-query';
import { BASE_URL } from '../../../constants/endpoints';
import { FEATURE_FLAG } from '../../../constants/general';
import { canUpgradeToUseFeature, validateFeatureFlag } from '../../../services/featureFlagService';
import { httpService } from '../../../services/http.service';
import { useStore } from '../../../store';

export enum SyncCardStatus {
  DONE = 'DONE',
  PENDING = 'PENDING',
  ERROR = 'ERROR',
}

export interface LinkedAccount {
  bankName: string;
  cardNumber: string;
  expired: boolean;
  type: 'CREDIT_CARD';
  institutionLogo: string;
  externalId: string;
  lastUpdated: Date;
  institutionId: string;
  syncStatus: SyncCardStatus;
}

export interface ExternalAccountResponse {
  externalAccountDataList: LinkedAccount[];
}

export const useLinkedAccounts = (onSuccess?: (data: LinkedAccount[]) => void) => {
  const { customerId } = useStore((state) => state.user);
  return useQuery(
    ['useLinkedAccounts', customerId],
    async () => {
      const { data } = await httpService.get<ExternalAccountResponse>(
        `${BASE_URL}/api/v1/user/${customerId}/externalAccount/accounts`,
      );

      return data.externalAccountDataList;
    },
    {
      onSuccess,
      staleTime: 10000,
      refetchInterval: (data: LinkedAccount[] | undefined) => {
        if (data?.length) {
          const hasPending = data.some((account) => account.syncStatus === SyncCardStatus.PENDING);
          return hasPending ? 3000 : false;
        }
        return false;
      },
      enabled: validateFeatureFlag(FEATURE_FLAG.SYNC_CARD) || canUpgradeToUseFeature(FEATURE_FLAG.SYNC_CARD),
    },
  );
};
